var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotsVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.0312 47.9375C35.0312 50.9923 32.5548 53.4688 29.5 53.4688C26.4452 53.4688 23.9688 50.9923 23.9688 47.9375C23.9688 44.8827 26.4452 42.4062 29.5 42.4062C32.5548 42.4062 35.0312 44.8827 35.0312 47.9375ZM35.0312 29.5C35.0312 32.5548 32.5548 35.0312 29.5 35.0312C26.4452 35.0312 23.9688 32.5548 23.9688 29.5C23.9688 26.4452 26.4452 23.9688 29.5 23.9688C32.5548 23.9688 35.0312 26.4452 35.0312 29.5ZM35.0312 11.0625C35.0312 14.1173 32.5548 16.5938 29.5 16.5938C26.4452 16.5938 23.9688 14.1173 23.9688 11.0625C23.9688 8.00767 26.4452 5.53125 29.5 5.53125C32.5548 5.53125 35.0312 8.00767 35.0312 11.0625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsVertical);
export default __webpack_public_path__ + "static/media/dots-vertical.95bbf3c746d9479256641f17203d71de.svg";
export { ForwardRef as ReactComponent };